import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './Button';
import { Globe } from 'lucide-react';
export function AppFooter() {
  const navigate = useNavigate();
  return <footer className="bg-slate-900 py-12 text-slate-300 sm:py-16" data-id="element-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4 lg:gap-8" data-id="element-52">
          <div className="md:col-span-1" data-id="element-53">
            <Link to="/" className="flex items-center gap-2 text-xl font-bold tracking-tight text-white hover:text-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-54">
              <Globe className="h-6 w-6 text-blue-500" data-id="element-55" />
              <span data-id="element-56">Affordable Medical Tourism</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-slate-400" data-id="element-57">
              Connecting patients with world-class, accredited healthcare
              facilities abroad.
            </p>
            <p className="mt-4 text-sm font-semibold text-slate-300" data-id="element-58">
              A product of Kosansh Solutions Inc.
            </p>
            <div className="mt-6" data-id="element-59">
              <Button variant="primary" onClick={() => navigate('/contact')} className="w-full sm:w-auto" data-id="element-60">
                Contact a Care Coordinator
              </Button>
            </div>
          </div>

          <div data-id="element-61">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white" data-id="element-62">
              Services
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-63">
              <li data-id="element-64">
                <Link to="/procedures" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-65">
                  Procedures
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/destinations" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-67">
                  Destinations
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/hospitals" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-69">
                  Hospitals & Clinics
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/facilitators" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-71">
                  Local Facilitators
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/how-it-works" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-73">
                  How It Works
                </Link>
              </li>
              <li data-id="element-74">
                <Link to="/patient-guide" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-75">
                  Patient Guide
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-76">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white" data-id="element-77">
              Company
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-78">
              <li data-id="element-79">
                <Link to="/about" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-80">
                  About Us
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/faq" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-82">
                  FAQ
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/contact" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-84">
                  Contact
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/partner-facility" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-86">
                  Facility Sign-up
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/partner-facilitator" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-88">
                  Facilitator Sign-up
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-89">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white" data-id="element-90">
              Legal
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-91">
              <li data-id="element-92">
                <Link to="/terms" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-93">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/privacy" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-95">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/medical-disclaimer" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-97">
                  Medical Disclaimer
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/accessibility" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-99">
                  Accessibility
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/cookie-policy" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-101">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/sitemap" className="text-sm hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-slate-900" data-id="element-103">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-800 pt-8 text-sm text-slate-400" data-id="element-104">
          <p data-id="element-105">
            &copy; {new Date().getFullYear()} Kosansh Solutions Inc. All rights
            reserved.
          </p>
          <p className="mt-2 text-xs leading-relaxed text-slate-500" data-id="element-106">
            Disclaimer: The information provided on this website is for
            educational purposes only and does not constitute medical advice.
            Pricing and savings percentages are illustrative and depend on
            individual treatment plans. Always consult with a qualified
            healthcare provider before making medical decisions.
          </p>
        </div>
      </div>
    </footer>;
}